// Team per project (wiki-feedback Ton, 15 okt 2026: "ik zie niet welk team erop zit").
// Bron = het projectrecord zelf: de koppelvelden Projectleider/Creative/Cameraman/Editor/Animator.
// Op main komt het record rechtstreeks uit Airtable (met naam-lookups voor een deel van de rollen),
// op develop uit de Postgres-spiegel (alleen record-ids). Daarom: id's vertalen via de personenlijst,
// en waar dat (nog) niet kan de naam-lookup van Airtable gebruiken. Nooit een kale recXXX tonen.

export const TEAM_ROLLEN = [
  { rol: 'Projectleider', veld: 'Projectleider', lookups: ['Projectleider (Volledige naam)', 'Projectleider (Voornaam)'] },
  { rol: 'Creative lead', veld: 'Creative', lookups: ['Naam (from Creative)'] },
  { rol: 'Camera', veld: 'Cameraman', lookups: ['Naam (from Cameraman)'] },
  { rol: 'Editor', veld: 'Editor', lookups: ['Naam (from Editor)'] },
  { rol: 'Animator', veld: 'Animator', lookups: ['Naam (from Animator)'] },
];

const alsLijst = (w) => (Array.isArray(w) ? w : [w]).filter((x) => x != null && String(x).trim() !== '');
const isRecordId = (s) => /^rec[A-Za-z0-9]{14}$/.test(String(s || ''));

// Zitten er id's in het record die we nog naar een naam moeten vertalen?
export function heeftTeamIds(fields) {
  return TEAM_ROLLEN.some(({ veld }) => alsLijst(fields?.[veld]).some(isRecordId));
}

// [{ rol, namen }] — alleen gevulde rollen, in vaste volgorde, namen ontdubbeld.
// `naamVanId`: Map of object id → naam (mag leeg zijn).
export function teamRollen(fields, naamVanId) {
  const f = fields || {};
  const zoek = (id) => (naamVanId instanceof Map ? naamVanId.get(id) : naamVanId?.[id]);
  const uit = [];
  for (const { rol, veld, lookups } of TEAM_ROLLEN) {
    const ids = alsLijst(f[veld]).filter(isRecordId);
    let namen = ids.map(zoek).filter(Boolean);
    if (namen.length < ids.length || !ids.length) {
      // Niet alles vertaald (of geen id's): de Airtable-lookup is dan de betere bron.
      const lookup = lookups.map((k) => alsLijst(f[k])).find((l) => l.length) || [];
      if (lookup.length >= namen.length) namen = lookup;
    }
    namen = [...new Set(namen.map((n) => String(n).trim()).filter((n) => n && !isRecordId(n)))];
    if (namen.length) uit.push({ rol, namen });
  }
  return uit;
}
